<template>
  <div class="doctorInfoContainer">
    <a-skeleton v-if="loading" avatar :paragraph="{ rows: 3 }" />
    <div class="doctorInfo" v-else>
      <div class="left">
        <auth-img :src="data.headUrl" alt="" class="avatar" />
      </div>
      <div class="right">
        <div class="top">
          <span class="name">{{ data.name }}</span>
          <span class="other">
            <span>{{ data.gender }}</span>
            <span class="line"></span>
            <span>{{ data.title }}</span>
          </span>
        </div>
        <div class="bottom">
          <span class="intro">简介：</span>
          <span class="introText">
            {{
              `${
                data.introduction?.length > introLength
                  ? ellipticalText(data.introduction, introLength)
                  : data.introduction || '--'
              }`
            }}
          </span>
          <span v-if="data.introduction?.length > introLength" class="more" @click="handleMore">
            更多
          </span>
        </div>
      </div>
      <a-modal
        :visible="introVisible"
        title="医生简介"
        @cancel="handleMore"
        :width="692"
        :footer="null"
        wrapClassName="introBox"
      >
        <p class="introText">
          <span class="intro">简介：</span>
          {{ `${data.introduction}` }}
        </p>
        <div class="footer">
          <a-button @click="handleMore">返回</a-button>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps } from 'vue'
import avatar from '@/assets/img/chat/head_a.png'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  loading: {
    type: Boolean,
    default: false
  }
})
const introVisible = ref(false)
const introLength = 258
const handleMore = () => {
  introVisible.value = !introVisible.value
}

// 文本超出长度省略
function ellipticalText(text, length) {
  if (!text || text === '') return
  const finalText = text?.length > length ? `${text?.substring(0, length)}...` : text
  return finalText
}
</script>

<style scoped lang="scss">
.doctorInfoContainer {
  background: url('../../../assets/img/register/doctor-info.png') no-repeat center;
  background-size: 100% 100%;
  padding: 24px 64px;
  margin-bottom: 32px;
  ::v-deep(.ant-skeleton-header .ant-skeleton-avatar-lg) {
    width: 107px;
    height: 150px;
  }
  ::v-deep(.ant-skeleton-header .ant-skeleton-avatar-lg.ant-skeleton-avatar-circle) {
    border-radius: 1px;
  }
}
.doctorInfo {
  display: flex;
  .avatar {
    display: inline-block;
    width: 107px;
    height: 150px;
    margin-right: 24px;
  }
  .right {
    padding: 10px 293px 15px 0;
    .top {
      margin-bottom: 15px;
      .name {
        font-size: 24px;
        color: #333;
        margin-right: 20px;
      }
      .other {
        font-size: 14px;
        color: #595959;
        .line {
          border-right: 1px solid #d9d9d9;
          padding: 0px 0;
          margin: 0 12px;
        }
      }
    }
    .bottom {
      color: #8c8c8c;
      font-size: 14px;
      line-height: 18px;
      .more {
        color: #1890ff;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
.introText {
  color: #595959;
}
.intro {
  color: #8c8c8c;
}
.footer {
  margin-top: 34px;
  text-align: center;
  button {
    width: 84px;
    height: 32px;
    font-size: 14px;
    color: #595959;
    border: 1px solid #bfbfbf;
    border-radius: 4px;
  }
}
</style>
